import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module list/listproperties/listpropertiesutils
 */
import { Plugin } from 'ckeditor5/src/core.js';
import { getAllSupportedStyleTypes as _getAllSupportedStyleTypes, getListStyleTypeFromTypeAttribute as _getListStyleTypeFromTypeAttribute, getListTypeFromListStyleType as _getListTypeFromListStyleType, getTypeAttributeFromListStyleType as _getTypeAttributeFromListStyleType } from './utils/style.js';
/**
 * A set of helpers related to document lists.
 */
var ListPropertiesUtils = /*#__PURE__*/function (_Plugin) {
  _inherits(ListPropertiesUtils, _Plugin);
  var _super = _createSuper(ListPropertiesUtils);
  function ListPropertiesUtils() {
    _classCallCheck(this, ListPropertiesUtils);
    return _super.apply(this, arguments);
  }
  _createClass(ListPropertiesUtils, [{
    key: "getAllSupportedStyleTypes",
    value:
    /**
     * Gets all the style types supported by given list type.
     */
    function getAllSupportedStyleTypes() {
      return _getAllSupportedStyleTypes();
    }
    /**
     * Checks whether the given list-style-type is supported by numbered or bulleted list.
     */
  }, {
    key: "getListTypeFromListStyleType",
    value: function getListTypeFromListStyleType(listStyleType) {
      return _getListTypeFromListStyleType(listStyleType);
    }
    /**
     * Converts `type` attribute of `<ul>` or `<ol>` elements to `list-style-type` equivalent.
     */
  }, {
    key: "getListStyleTypeFromTypeAttribute",
    value: function getListStyleTypeFromTypeAttribute(value) {
      return _getListStyleTypeFromTypeAttribute(value);
    }
    /**
     * Converts `list-style-type` style to `type` attribute of `<ul>` or `<ol>` elements.
     */
  }, {
    key: "getTypeAttributeFromListStyleType",
    value: function getTypeAttributeFromListStyleType(value) {
      return _getTypeAttributeFromListStyleType(value);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'ListPropertiesUtils';
    }
  }]);
  return ListPropertiesUtils;
}(Plugin);
export { ListPropertiesUtils as default };